import { fromFetch } from 'rxjs/fetch';

export default () => {
  const requestObject = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    selector: (response) => response.json(),
  };
  return fromFetch('/configuration/getvalues', requestObject);
};